import { CropMode } from '@/utils/types';

export const RATIOS = {
    [CropMode.Square]: 1,
    [CropMode.Vertical]: 9 / 16,
    [CropMode.Wide]: 16 / 9,
} as Record<CropMode, number>;

export const BREAKPOINTS = {
    LARGE: 1000,
    MEDIUM: 750,
    SMALL: 500,
} as const;

export const COLUMNS = {
    LARGE: 4,
    MEDIUM: 3,
    SMALL: 2,
    XSMALL: 1,
} as const;

export const TILE_SPACING = {
    BOTTOM_PADDING: 24,
    TITLE_MARGIN_TOP: 8,
} as const;
